export const STATURA_CARE_PUBLIC_URLS = {
  terms: 'https://statura.care/terms',
  privacy: 'https://statura.care/privacy',
  support: 'https://statura.care/support',
  accountDeletion: 'https://statura.care/account/delete',
  security: 'https://statura.care/security',
  customerLegalPack: 'https://statura.care/legal',
  customerMsa: 'https://statura.care/legal/master-services-agreement',
  customerDataProcessing: 'https://statura.care/legal/data-processing-schedule',
  customerSubprocessors: 'https://statura.care/legal/subprocessor-schedule',
} as const;

export const STATURA_CARE_LEGAL_ENTITY_NAME = 'Statura Operations Pty Ltd';
export const STATURA_CARE_LEGAL_ENTITY_ACN = '696 303 269';
export const STATURA_CARE_LEGAL_ENTITY_ABN = '70 696 303 269';
export const STATURA_CARE_LEGAL_ENTITY_FULL =
  'Statura Operations Pty Ltd (ACN 696 303 269, ABN 70 696 303 269), trading as Statura Care';

export const STATURA_CARE_SUPPORT_EMAIL = 'support@statura.care';
export const STATURA_CARE_PRIVACY_EMAIL = 'privacy@statura.care';
export const STATURA_CARE_LEGAL_EMAIL = 'legal@statura.care';

// These versions intentionally match the currently published public documents on statura.care.
export const STATURA_CARE_TERMS_VERSION = '2026-03-26';
export const STATURA_CARE_PRIVACY_VERSION = '2026-04-17';
export const STATURA_CARE_REPRESENTATIVE_AUTHORITY_VERSION = '2026-04-23';
export const STATURA_CARE_CUSTOMER_MSA_VERSION = '2026-04-23';
export const STATURA_CARE_CUSTOMER_DPA_VERSION = '2026-04-23';
export const STATURA_CARE_CUSTOMER_SUBPROCESSOR_VERSION = '2026-04-23';
export const STATURA_CARE_CUSTOMER_SIGNATORY_AUTHORITY_VERSION = '2026-04-23';
export const STATURA_CARE_WORKER_COLLECTION_NOTICE_VERSION = '2026-07-13';
